import type { CrmTranslate } from './crm-copy';

export function createCrmPacksCopy(t: CrmTranslate) {
  return {
    packs: {
      section: {
        title: t('crm.packs.section.title'),
        description: t('crm.packs.section.description'),
        readOnly: t('crm.packs.section.readOnly'),
        loadFailed: t('crm.packs.section.loadFailed'),
      },
      labels: {
        installed: (version: number) =>
          t('crm.packs.labels.installed', {
            values: { version },
          }),
        available: (version: number) =>
          t('crm.packs.labels.available', { values: { version } }),
        contents: (objects: number, fields: number, pipelines: number) =>
          t('crm.packs.labels.contents', {
            values: { objects, fields, pipelines },
          }),
        sampleData: t('crm.packs.labels.sampleData'),
      },
      actions: {
        install: t('crm.packs.actions.install'),
        upgrade: (version: number) =>
          t('crm.packs.actions.upgrade', {
            values: { version },
          }),
        uninstall: t('crm.packs.actions.uninstall'),
        cancel: t('crm.packs.actions.cancel'),
        uninstallTitle: t('crm.packs.actions.uninstallTitle'),
        confirmUninstall: (label: string) =>
          t('crm.packs.actions.confirmUninstall', {
            values: { label },
          }),
      },
      messages: {
        installed: t('crm.packs.messages.installed'),
        upgraded: t('crm.packs.messages.upgraded'),
        uninstalled: t('crm.packs.messages.uninstalled'),
        failed: t('crm.packs.messages.failed'),
      },
    },
  };
}
